import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'
import { monthlyDropdownList } from '../../../Data/Dashboard/Default'
import { Link } from 'react-router-dom'
import { Badges, H5, Image, LI, UL } from '../../../AbstractElements'
import { dynamicImage, dynamicNumber } from '../../../Utils'
import { trendingProductList } from '../../../Data/Dashboard/Ecommerce'

export default function TrendingProduct() {
    return (
        <Col xxl={5} xl={7} className="box-col-7">
            <Card className="product-card">
                <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Trending Product "} />
                <CardBody>
                    <div className="d-flex">
                        {trendingProductList.map((item) => (
                            <div className="card-product" key={item.id}>
                                <Link to={`${process.env.PUBLIC_URL}/ecommerce/products`}>
                                    <span><Image src={dynamicImage(`dashboard-2/product/${item.image}`)} alt="" /></span>
                                    {item.badge && <Badges color={item.badgeColor}>{item.badge}</Badges>}
                                    <div className="details-product">
                                        <H5>{item.product}</H5>
                                        <UL className='simple-list flex-row'>
                                            {dynamicNumber(5).map((item) => (
                                                <LI key={item}><i className="fa fa-star" /></LI>
                                            ))}
                                        </UL>
                                        <div className="price-product">${item.price}
                                            <del>${item.deletePrice}</del>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}
